export default __webpack_public_path__ + "static/media/F0002.1620afaf.png";